import { forwardRef } from 'react';
import type { SelectHTMLAttributes, ReactNode } from 'react';

export interface SelectProps extends Omit<SelectHTMLAttributes<HTMLSelectElement>, 'className'> {
  readonly className?: string;
  readonly invalid?: boolean;
  readonly children?: ReactNode;
}

/**
 * Select uses the `.select-v2` class so the chevron-via-background-svg
 * styling applies. The legacy raw-`select` element rules from
 * styles.css still apply for any non-prefixed <select>.
 */
export const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { className, invalid, children, ...rest },
  ref,
) {
  const cls = ['select-v2', invalid ? 'select-invalid' : '', className ?? ''].filter(Boolean).join(' ');
  return (
    <select ref={ref} className={cls} aria-invalid={invalid || undefined} {...rest}>
      {children}
    </select>
  );
});
